import PropTypes from "prop-types";
import React, { useEffect, useRef, useState } from "react";
import SignupForm from "./SignupForm";
import LoginForm from "./LoginForm";
import RequireSignup from "./RequireSignup/RequireSignup";
import { useFeatureFlags } from "../../hooks";

import {
  sendLoginPromptViewEvent,
  sendSignupPromptViewEvent
} from "@wattpad/client-platform-web-events";

const FormTypes = {
  SIGNUP: "signup",
  LOGIN: "login"
};

const sendPromptViewEvent = (formName, eventDetails) => {
  if (formName === FormTypes.SIGNUP) {
    sendSignupPromptViewEvent(eventDetails);
  } else if (formName === FormTypes.LOGIN) {
    sendLoginPromptViewEvent(eventDetails);
  }
};

const AuthForm = ({
  focus,
  formType,
  fullScreen,
  msg,
  nextUrl,
  notice,
  subtitle,
  title,
  login = false,
  eventSource
}) => {
  const featureflags = useFeatureFlags();
  const authFormRef = useRef(null);

  const [formName, setFormName] = useState(
    login ? FormTypes.LOGIN : FormTypes.SIGNUP
  );

  useEffect(
    () => {
      if (
        !authFormRef.current ||
        !eventSource ||
        typeof eventSource?.page !== "object" ||
        !eventSource?.component
      )
        return;

      const currentRef = authFormRef.current;

      const observer = new IntersectionObserver(
        entries => {
          if (entries[0].isIntersecting) {
            sendPromptViewEvent(formName, eventSource);
            observer.unobserve(currentRef);
          }
        },
        {
          root: null,
          rootMargin: "0px",
          threshold: 0.5
        }
      );

      observer.observe(currentRef);

      return () => {
        if (currentRef) {
          observer.unobserve(currentRef);
        }
      };
    },
    [authFormRef, formName, eventSource]
  );

  const toggleForm = () =>
    setFormName(
      formName === FormTypes.LOGIN ? FormTypes.SIGNUP : FormTypes.LOGIN
    );

  const form =
    formName === FormTypes.SIGNUP ? (
      <SignupForm
        focus={focus}
        formType={formType}
        nextUrl={nextUrl}
        subtitle={subtitle}
        title={title}
        toggleForm={toggleForm}
        ref={authFormRef}
      />
    ) : (
      <LoginForm
        focus={focus}
        msg={msg}
        nextUrl={nextUrl}
        notice={notice}
        toggleForm={toggleForm}
        ref={authFormRef}
      />
    );

  if (fullScreen) {
    return (
      <div className="authentication-wrapper">
        {/* TODO: check fields <SignupForm /> is using above and what is needed. And add them here. */}
        <RequireSignup nextUrl={nextUrl} eventSource={eventSource} />
      </div>
    );
  } else {
    return form;
  }
};

AuthForm.propTypes = {
  focus: PropTypes.bool,
  formType: PropTypes.string,
  fullScreen: PropTypes.bool,
  login: PropTypes.bool,
  msg: PropTypes.string,
  nextUrl: PropTypes.string,
  notice: PropTypes.string,
  signup: PropTypes.bool,
  signupFrom: PropTypes.string,
  subtitle: PropTypes.string,
  title: PropTypes.string,
  eventSource: PropTypes.shape({
    page: PropTypes.object,
    component: PropTypes.string
  })
};

export default AuthForm;
